<template>
  <div>
    <banner :title="'工程案例'"></banner>
    <preview v-if="visable" :imgList="honerList" @close="close"></preview>
    <div class="list">
      <div class="l-title">
        <span>
          <b>工程案例</b>
        </span>
      </div>
      <div class="container row" style="margin: 0 auto">
        <div
          class="col-md-4 col-6"
          style="box-sizing: border-box; margin-bottom: 20px"
          v-for="(honer, index) in honerList"
          :key="index"
        >
          <a class="lightbox" @click="preview">
            <div class="item">
              <div class="pic">
                <img :src="honer.img" :alt="honer.label" />
                <i class="iconfont icon-yulan"></i>
              </div>
              <div class="txt">
                <p class="t1 ellipsis">{{ honer.label }}</p>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import banner from "../components/banner.vue";
import preview from "../components/preview.vue";
export default {
  components: {
    banner,
    preview,
  },
  data() {
    return {
      visable: false,
      honerList: [
        {
          img: "/case/case1.webp",
          label: "案例展示",
        },
        {
          img: "/case/case2.webp",
          label: "案例展示",
        },
        {
          img: "/case/case3.webp",
          label: "案例展示",
        },
        {
          img: "/case/case4.webp",
          label: "案例展示",
        },
        {
          img: "/case/case5.webp",
          label: "案例展示",
        },
        {
          img: "/case/case6.webp",
          label: "案例展示",
        },
        {
          img: "/case/case7.webp",
          label: "案例展示",
        },
        {
          img: "/case/case8.webp",
          label: "案例展示",
        },
        {
          img: "/case/case9.webp",
          label: "案例展示",
        },
      ],
    };
  },
  methods: {
    close() {
      this.visable = false;
    },
    preview() {
      this.visable = true;
    },
  },
};
</script>

<style lang="less" scoped>
.lightbox {
  .item {
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    overflow: hidden;
    transition: all 0.5s;
    border: solid 1px #eee;
    .pic {
      width: 100%;
      height: 250px;
      position: relative;
      overflow: hidden;
      &:after {
        width: 0;
        height: 0;
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.8);
        transition: all 0.5s;
        border-radius: 50%;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        position: absolute;
      }
      i {
        color: #fff;
        font-size: 50px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 1;
        opacity: 0;
        transition: all 0.5s;
      }
    }
    .txt {
      background: #f6f5f5;
      padding: 15px;
      transition: all 0.5s;
      color: #333;
      font-size: 16px;
      font-weight: 700;
    }
    &:hover {
      box-shadow: 0 0 10px #999;
      i {
        opacity: 1;
      }
      .pic:after {
        width: 200%;
        height: 200%;
        left: -50%;
        top: -50%;
      }
      // .txt {
      //   background: @primaryColor;
      //   color: #fff;
      // }
    }
  }
}

.l-title b:after {
  content: "";
  width: 100px;
  height: 3px;
  background: @primaryColor;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  bottom: 0;
}
.list .warp p {
  text-align: left;
}
</style>
